/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportCogsProducts
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.reports.cogs')
.factory('ReportCogs', ["$resource", "settings", function($resource, settings) {

  var CogsProductsSummary;
  var CogsProductsDetail;
  var CogsPurchases;

  CogsProductsSummary = $resource(settings.mercHost + '/cogs/products/summary');
  CogsProductsDetail = $resource(settings.mercHost + '/cogs/products/detail');
  CogsPurchases = $resource(settings.mercHost + '/cogs/purchases');

  function getProductsSummary(startTime, endTime, interval) {
    return CogsProductsSummary.query({start: startTime, end: endTime, interval: interval}).$promise;
  }

  function getProductsDetail(startTime, endTime) {
    return CogsProductsDetail.query({start: startTime, end: endTime}).$promise;
  }

  function getPurchasesSummary(startTime, endTime, interval) {
    return CogsPurchases.query({start: startTime, end: endTime, interval: interval}).$promise;
  }

  return {
    getProductsSummary: getProductsSummary,
    getProductsDetail: getProductsDetail,
    getPurchasesSummary: getPurchasesSummary
  };
}]);
